import axios, {AxiosResponse} from "axios";
import {retry} from "@me8eon/retry_utils";
import {ellipsesInMiddle} from "@me8eon/string_utils";
import {EnvironmentConfig} from "@me8eon/config";
import {GetServiceRequestOrdersResponse} from "./model/types";
import {AiToolImpl} from "@me8eon/aiclient";
import { JwtTokenFn } from "@me8eon/authentication";

export const GetUserOrdersToolImplGenerator = (jwtTokenFn: JwtTokenFn): AiToolImpl<any> => {
    return {
        type: "service_api",
        toolDefn: {
            type: 'function',
            name: "get_user_orders",
            description: "This tool fetches the user's current IT orders from the ServiceNow platform. It returns a list of IT order requests with their details.",
            parameters: {
                required: [],
                additionalProperties: false,
                type: "object",
                properties: {}
            },
        },
        execute: async () => {
            try {

                const asyncFn: () => Promise<AxiosResponse<GetServiceRequestOrdersResponse>> = async () => await axios.get(`${EnvironmentConfig.nodeService}/service/orders?isActive=true`, {
                    headers: { Authorization: `Bearer ${await jwtTokenFn()}` },
                });

                const response = await retry(asyncFn)

                const orderData = response.data.result.queryResult.map((item) => ({
                    ...item,
                    cat_item: ellipsesInMiddle(item.cat_item, 100)
                }));
                const ordersJson = JSON.stringify(orderData, null, 2);

                return {
                    value: `Here are the user's IT orders:\n\n${ordersJson}`
                }
            } catch (error) {
                return {
                    value: `Could not fetch user IT orders due to an error. User should be informed accordingly.`
                }
            }
        }
    }
}